/* ═══════════════════════════════════════════════════════════════════════════
   FIELD & FLETCH — Custom JavaScript
   Only features that genuinely require JS.
   ═══════════════════════════════════════════════════════════════════════════ */

;(function () {
  'use strict';

  /* ───────────────────────────────────────────────────────────────────────────
     1. SCROLL-REVEAL  (IntersectionObserver for .reveal-on-scroll)
     ─────────────────────────────────────────────────────────────────────────── */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    document.querySelectorAll('.reveal-on-scroll').forEach(function (el) {
      io.observe(el);
    });
  }


  /* ───────────────────────────────────────────────────────────────────────────
     2. HEADER — adds .is-scrolled to <header> after 60 px
     ─────────────────────────────────────────────────────────────────────────── */
  function initHeader() {
    var header = document.querySelector('header.header');
    if (!header) return;

    var THRESHOLD = 60;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          header.classList.toggle('is-scrolled', window.scrollY > THRESHOLD);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }


  /* ───────────────────────────────────────────────────────────────────────────
     3. MARQUEE — duplicate inner content for seamless loop
     ─────────────────────────────────────────────────────────────────────────── */
  function initMarquee() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar || bar.dataset.ffMarquee === 'ready') return;

    var inner = bar.querySelector('.announcement-bar__message') ||
                bar.querySelector('p') ||
                bar.firstElementChild;
    if (!inner) return;

    var track = document.createElement('div');
    track.style.cssText =
      'display:flex;white-space:nowrap;animation:ff-marquee 22s linear infinite;';
    var clone = inner.cloneNode(true);
    clone.style.marginLeft = '4rem';
    track.appendChild(inner.cloneNode(true));
    track.appendChild(clone);

    inner.replaceWith(track);
    bar.dataset.ffMarquee = 'ready';
  }


  /* ───────────────────────────────────────────────────────────────────────────
     4. STICKY MOBILE CTA
     ─────────────────────────────────────────────────────────────────────────── */
  function initStickyCta() {
    if (document.getElementById('ff-sticky-cta')) return;

    var hero = document.querySelector('.shopify-section:first-of-type');
    if (!hero) return;

    var cta = document.createElement('div');
    cta.id = 'ff-sticky-cta';
    cta.innerHTML = '<a href="/products/trophy-portrait">CREATE YOUR PORTRAIT →</a>';
    document.body.appendChild(cta);

    if ('IntersectionObserver' in window) {
      var ob = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            cta.style.display = e.isIntersecting ? 'none' : 'block';
          });
        },
        { threshold: 0 }
      );
      ob.observe(hero);
    }
  }


  /* ───────────────────────────────────────────────────────────────────────────
     INIT
     ─────────────────────────────────────────────────────────────────────────── */
  function init() {
    initHeader();
    initMarquee();
    initStickyCta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    initMarquee();
    initHeader();
    initStickyCta();
  });

})();
